var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{staticClass:"primaryBtn",on:{"click":_vm.compareAct}},[_vm._v("Compare")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }